import ConfirmDialog from "@core/components/confirm-dialog/ConfirmDialog.vue";
import { VoucherService } from "@/api/voucher-service.js";
import { commonServices } from "@/api/common-services";
import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxEditing,
  DxPager,
  DxFilterRow,
  DxScrolling
} from "devextreme-vue/data-grid";
import "devextreme/dist/css/dx.light.css";
import VocherDetail from "./VocherDetail/VocherDetail.vue";
import Pagination from "@/views/modules/ultils/Pagination/Pagination.vue";

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxEditing,
    DxPager,
    DxFilterRow,
    DxScrolling,
    VocherDetail,
    Pagination,
    "confirm-dialog": ConfirmDialog,
  },
  props: {
    VoucherDefinitionIdProps: {
      type: Number,
      default: 0,
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      search: {
        VoucherCode: null,
        VoucherStatus: null,
        OpenDate: null,
        ExpirationDate: null,
        VoucherDefinitionId: null,
        ClientId: [],
        DateType: "OpenDate",
      },
      dateType: { label: this.$t("ar_voucher_opendate"), code: "OpenDate" },
      listDateType: [
        { label: this.$t("ar_voucher_opendate"), code: "OpenDate" },
        { label: this.$t("ar_voucher_expirationdate"), code: "ExpirationDate" },
      ],
      listVoucherStatus: [
        { label: this.$t('ar_voucher_effective'), code: "VALID" },
        { label: this.$t('ar_voucher_used'), code: "USED" },
        { label: this.$t('ar_voucher_list_voucher_pause'), code: "PAUSE" },
      ],
      listWeeklyCode: [
        {
          text: this.$t("ar_voucher_monday"),
          value: "MON",
        },
        {
          text: this.$t("ar_voucher_tuesday"),
          value: "TUE",
        },
        {
          text: this.$t("ar_voucher_wednesday"),
          value: "WED",
        },
        {
          text: this.$t("ar_voucher_thursday"),
          value: "THU",
        },
        {
          text: this.$t("ar_voucher_friday"),
          value: "FRI",
        },
        {
          text: this.$t("ar_voucher_saturday"),
          value: "SAT",
        },
        {
          text: this.$t("ar_voucher_sunday"),
          value: "SUN",
        },
      ],
      configTable: [
        {
          caption: this.$t("ar_voucher_clinent_name"),
          field: "ClientName",
          isShow: true,
          cellTemplate: "ClientName",
          alignment: "center",
          width: "15%",
        },
        {
          caption: this.$t("ar_voucher_code_voucher"),
          field: "VoucherCode",
          isShow: true,
          cellTemplate: "VoucherCode",
          alignment: "center",
          width: "15%",
        },
        {
          caption: this.$t("ar_voucher_name_voucher"),
          field: "VoucherName",
          isShow: true,
          cellTemplate: "VoucherName",
          alignment: "center",
          width: "15%",
        },
        {
          caption: this.$t("ar_voucher_release_date"),
          field: "OpenDate",
          isShow: true,
          cellTemplate: "OpenDate",
          alignment: "center",
          width: "15%",
        },
        {
          caption: this.$t("ar_voucher_expiration_date"),
          field: "ExpirationDate",
          isShow: true,
          cellTemplate: "ExpirationDate",
          alignment: "center",
          width: "15%",
        },
        {
          caption: this.$t("ar_voucher_date_application"),
          field: "WeeklyCode",
          isShow: true,
          cellTemplate: "WeeklyCode",
          alignment: "center",
          width: "15%",
        },
        {
          caption: this.$t("ar_voucher_status"),
          field: "VoucherStatus",
          cellTemplate: "VoucherStatus",
          isShow: true,
          alignment: "center",
          width: "10%",
        },
        {
          caption: this.$t("ar_voucher_uses"),
          field: "MediaTypeId",
          cellTemplate: "MediaTypeId",
          isShow: true,
          alignment: "center",
          width: "10%",
        },
        {
          caption: this.$t("ar_voucher_deadline_status"),
          field: "VoucherStatusEx",
          cellTemplate: "VoucherStatusEx",
          isShow: true,
          alignment: "center",
          width: "15%",
        },
        {
          caption: "",
          field: "action",
          cellTemplate: "action",
          width: "10%",
          alignment: "left",
        },
      ],
      isLoading: true,
      currentPage: 0,
      perPage: 10,
      optionPerPage: [10, 20, 50],
      listVoucher: [],
      voucherDetailId: null,
      isShowModalDetails: false,
      openDateDisplay: this.getUTC("start", "month"),
      expirationDateDisplay: this.getUTC("end", "month"),
      listUsesVoucher: [
        { label: this.$t("ar_voucher_paper_voucher"), code: 0 },
        { label: this.$t("ar_voucher_electron_voucher"), code: 1 },
      ],
      listCompany: [],
      searchClinentId: null,
      dataGridRef: "tableRate",
      totalRecordListVoucer: 0,
      totalEffectiveListVoucer: 0,
      totalPauseListVoucer : 0,
      totalUsedListVoucer : 0,
      currentPageDisplay: 1,
    };
  },
  methods: {
    async getListVoucher() {
      this.isLoading = true;
      const body = {
        VoucherCode: this.search.VoucherCode,
        OpenDate: this.search.VoucherCode === null | this.search.VoucherCode === '' ? this.search.OpenDate : null,
        ExpirationDate: this.search.VoucherCode === null | this.search.VoucherCode === '' ? this.search.ExpirationDate : null,
        VoucherDefinitionId: this.search.VoucherDefinitionId,
        ClientId: this.search.ClientId,
        DateType: this.search.DateType,
        Idmax: this.currentPage,
        NumberOfRow: this.perPage,
      };
      if (this.search.VoucherStatus) {
        body.VoucherStatus = this.search.VoucherStatus.code;
      } else {
        body.VoucherStatus = null;
      }
      await VoucherService.getListVoucher_VC_RV01(body).then((res) => {
        this.isLoading = false;
        if (res.Status !== "200") {
          this.showResToast(res);
          return;
        }
        this.listVoucher = [];
        this.listVoucher = [...res.Data.Total.Voucher];
        this.totalRecordListVoucer = res.Data.Total.TotalNumber;
        this.totalEffectiveListVoucer = res.Data.Total.Valid;
        this.totalPauseListVoucer = res.Data.Total.Pause;
        this.totalUsedListVoucer = res.Data.Total.Used;
        this.listVoucher.forEach((item, index) => this.$set( this.listVoucher[index], 'ClientName', item.VoucherDefinition.ClientName));
        this.listVoucher.map((item) => item.ClientName = item.ClientName === null ? this.$t("ar_voucher_not_company") : item.ClientName);
        this.listVoucher.forEach((item) => {
          const arrayWeeklyCode = [];
          item.WeeklyCode.forEach((itemWeeklyCode) => {
            const findTranslate = this.listWeeklyCode.filter(
              (item) => item.value === itemWeeklyCode
            );
            arrayWeeklyCode.push(findTranslate[0].text);
          });
          item.WeeklyCode = arrayWeeklyCode.toString();
        })
      });
    },
    getCompany() {
      commonServices.getCompany().then((res) => {
        if (res.Status !== "200") {
          this.showResToast(res);
          return;
        }
        res.Data.Client.forEach((item) => {
          this.listCompany.push({ label: item.ClientName, code: item.Id });
        });
      });
    },
    handleClickDetailVoucher(Id) {
      this.voucherDetailId = Id;
      this.isShowModalDetails = !this.isShowModalDetails;
    },
    viewDetailVoucher(data) {
      this.handleClickDetailVoucher(data.data.Id);
    },
    async DeleteVoucher(data) {
      const body = {
        Voucher: {
          Id: data.Id,
        },
      };
      await VoucherService.deteleDetailVoucher_VC_DV01(body).then((res) => {
        this.showResToast(res);
        if (res.Status === "200") {
          this.getListVoucher();
        }
      });
    },
    async validDetailVoucher(data) {
      const body = {
        Voucher: {
          Id: data.Id,
        },
      };

      await VoucherService.validDetailVoucher_VC_UV03(body).then((res) => {
        this.showResToast(res);
        if (res.Status === "200") {
          this.getListVoucher();
        }
      });
    },
    async invalidDetailVoucher(data) {
      const body = {
        Voucher: {
          Id: data.Id,
        },
      };
      await VoucherService.invalidDetailVoucher_VC_UV02(body).then((res) => {
        this.showResToast(res);
        if (res.Status === "200") {
          this.getListVoucher();
        }
      });
    },
    handleEvent(result) {
      if (result.type === "after-update_voucher") {
        this.getListVoucher();
      }
      if (result.type === "after-delete_voucher") {
        this.$bvModal.hide("modal-voucher-detail");
        this.getListVoucher();
      }
    },
    refillSearchDate() {
      this.search.OpenDate = this.getUTC("start", "month");
      this.search.ExpirationDate = this.getUTC("end", "month");
    },
    viewDetailListVoucher(value) {
      if (value.column.cellTemplate === "action") {
        return;
      }
      this.handleClickDetailVoucher(value.data.Id);
    },
    async exportExcelListVoucher() {
      const body = {
        VoucherCode: this.search.VoucherCode,
        OpenDate: this.search.VoucherCode === null | this.search.VoucherCode === '' ? this.search.OpenDate : null,
        ExpirationDate: this.search.VoucherCode === null | this.search.VoucherCode === '' ? this.search.ExpirationDate : null,
        VoucherDefinitionId: this.search.VoucherDefinitionId,
        ClientId: this.search.ClientId,
        DateType: this.search.DateType,
        Idmax: null,
        NumberOfRow: null,
      };
      await VoucherService.getExcelListVoucher_VCRV01E(body).then(res => {
        const decodedData = Buffer.from(res.Data.FileContents, 'base64')
        const newBlob = new Blob([decodedData], {
          type: 'application/xlsx',
        })
        var a = document.createElement("a");
        a.href = URL.createObjectURL(newBlob);
        a.setAttribute("download", `ListVoucher.xlsx`);
        a.click();
      })

    },
    exportPDFVoucher() {
      this.exportPDF(this.dataGrid);
    },
    confirmInvalid(id) {
      this.invalidDetailVoucher({ Id: id });
    },
    confirmValid(id) {
      this.validDetailVoucher({ Id: id });
    },
  },
  computed: {
    dataGrid() {
      return this.$refs[this.dataGridRef].instance;
    },
  },
  watch: {
    VoucherDefinitionIdProps(value) {
      this.search.VoucherDefinitionId = value;
    },
    isOpen(value) {
      if (value) {
        this.getListVoucher();
      }
      this.$emit("update:isOpen", value);
    },
    openDateDisplay(value) {
      this.search.OpenDate = this.dayjs(value).add(1, 'day').utc().format();
    },
    expirationDateDisplay(value) {
      this.search.ExpirationDate = this.dayjs(value).add(1, 'day').endOf('day').utc().format();
    },
    searchClinentId(value) {
      this.search.ClientId = [];
      if (value) {
        this.search.ClientId.push(value.code);
      }
    },
    dateType(value) {
      this.search.DateType = value.code;
    },
    perPage() {
      this.getListVoucher();
    },
    currentPageDisplay(value) {
      this.currentPage =
        value === 1
          ? 0
          : (value * 10) + this.listVoucher[this.listVoucher.length - 1].Id - 10;
      this.getListVoucher();
    },
  },
  created() {
    if (this.$router.currentRoute.name === "ListVoucher") {
      this.refillSearchDate();
      setTimeout(() => this.getListVoucher(), 500);
    }
    this.getCompany();
  },
};
